module.exports = __webpack_public_path__ + "img/1551064493.22ba00b4.jpg";